<template>
  <PrivacySection title="5. Dati Conservati e Motivazioni">
    <p>
      In alcuni casi, potremmo conservare determinati dati anche dopo una richiesta
      di cancellazione, esclusivamente per obblighi di legge o per tutelare i nostri
      diritti legittimi:
    </p>
    <ul>
      <li>
        <strong>Obblighi legali:</strong> dati che devono essere conservati per
        adempiere a obblighi normativi, fiscali o contabili
      </li>
      <li>
        <strong>Difesa in giudizio:</strong> dati necessari per l'esercizio o la
        difesa di un diritto in sede giudiziaria
      </li>
      <li>
        <strong>Dati già anonimizzati:</strong> statistiche aggregate che non
        consentono l'identificazione dell'utente
      </li>
    </ul>
    <PrivacyBox>
      <p>
        <strong>Periodo di conservazione residuo:</strong> i dati conservati per
        obblighi legali saranno eliminati non appena l'obbligo di conservazione
        cesserà, e comunque entro i termini massimi previsti dalla legge applicabile.
      </p>
    </PrivacyBox>
  </PrivacySection>
</template>

<script>
import PrivacySection from '@/components/privacy/PrivacySection.vue'
import PrivacyBox from '@/components/privacy/PrivacyBox.vue'

export default {
  name: 'RetentionSection',
  components: {
    PrivacySection,
    PrivacyBox
  }
}
</script>
